/* eslint-disable import/prefer-default-export */
import axios from "axios";
import gql from "graphql-tag";
import getMaintenanceMode, { getFingerprint } from "../../utilities";

const graphql = require("graphql");

const { print } = graphql;

interface SessionDetails {
  correlationId: string;
  brand: string;
  country: string;
  source: string;
  language: string;
  token: string;
  shouldLinkAccount?: boolean;
}

interface Payload {
  partyId: number;
  mfaCode: string;
  rememberDevice: boolean;
  sessionDetails: SessionDetails;
}

const gqlRequest = gql`
  query VerifyCustomerMFAIntegrated($Request: VerifyCustomerMFAIntegratedRequest!) {
    verifyCustomerMFAIntegrated(Request: $Request) {
      IsSuccess
      IsMfaVerified
      DefaultAccountNumber
      Token {
        AccessToken
        ExpiresIn
        TokenType
        RefreshToken
        IdToken
      }
      PartyId
      Errors {
        ErrorCode
        ErrorMessage
        ErrorStack
      }
      LoginAttemptCount
    }
  }
`;

export const verifyCustomerMFAIntegrated = async (payload: Payload) => {
  const { mfaCode, partyId, rememberDevice, sessionDetails } = payload;
  try {
    const userFingerprint = await getFingerprint();
    const getMode = await getMaintenanceMode();
    if (getMode === true) {
      return {
        data: {
          inMaintenance: "Y",
        },
      };
    }
    const request = {
      PartyId: partyId,
      MFACode: `${mfaCode}`,
      Fingerprint: `${userFingerprint}`,
      RememberMe: rememberDevice,
      ShouldLinkAccount: sessionDetails.shouldLinkAccount ?? false,
      Brand: sessionDetails.brand,
      Country: sessionDetails.country,
      CorrelationId: sessionDetails.correlationId,
      ParentFunctionName: "VerifyMFACode",
      ProcessName: "VerifyMFACode",
      SourceApp: sessionDetails.source,
      WidgetName: sessionDetails.source,
    };
    const appsyncUrl = process.env.REACT_APP_APPSYNC_URL ?? '';
    const url = `${appsyncUrl}/customerauth/authenticated/graphql`;
    const response = await axios({
      url: url,
      method: "post",
      headers: {
        "Authorization": sessionDetails.token,
      },
      data: {
        query: print(gqlRequest),
        variables: {
          Request: request,
        },
      },
    });
    if (
      response?.data?.data?.verifyCustomerMFAIntegrated?.IsSuccess &&
      response?.data?.data?.verifyCustomerMFAIntegrated?.IsMfaVerified
    ) {
      return {
        data: {
          isSuccess: true,
          isVerified: true,
          token: response?.data?.data?.verifyCustomerMFAIntegrated?.Token?.IdToken,
          accountNumber:
            response?.data?.data?.verifyCustomerMFAIntegrated?.DefaultAccountNumber,
        },
      };
    }

    if (response?.data?.data?.verifyCustomerMFAIntegrated?.LoginAttemptCount) {
      return {
        data: {
          isSuccess: true,
          isVerified: false,
          loginAttemptCount:
            response?.data?.data?.verifyCustomerMFAIntegrated?.LoginAttemptCount,
        },
      };
    }

    if (
      response?.data?.data?.verifyCustomerMFAIntegrated?.Errors ||
      response?.data?.data === null
    ) {
      return {
        data: {
          isSuccess: true,
          errors:
            response?.data?.data?.verifyCustomerMFAIntegrated?.Errors ||
            response?.data?.errors ||
            "",
        },
      };
    }

    return {
      data: {
        isSuccess: false,
        error:
          response?.data?.errors ||
          response?.data?.data?.error ||
          response?.data ||
          response,
      },
    };
  } catch (error) {
    const normalizedError = error as Error;
    return { error: normalizedError.message || normalizedError.toString() };
  }
};
